export enum ActionStatus {
  ONGOING = 'ongoing',
  DONE = 'done',
  DONE_LATE = 'doneLate',
  NOT_DONE = 'notDone',
  ONGOING_LATE = 'ongoingLate',
}
